import type { JSX, ChangeEvent, ReactNode, FC } from "react";

import { Header } from "app/components/sharingAssetModal/components/Header";
import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { SharingOptionsContainer } from "app/components/SharingModal/components/SharingOptionsContainer/SharingOptionsContainer";
import { ContentContainer } from "app/pages/dashboard/SharedDashboardModal/SharedDashboardModal.styled";
import type {
    ISharingModalTextContainer,
    ISharingModalState,
    IUserInfoExtended,
} from "app/components/SharingModal/types";

type ISharingModalProps = {
    modalProps: IProModal;
    headerProps: ISharingModalTextContainer["header"];
    text: ISharingModalTextContainer["sharingOptionTextContainer"];
    users: IUserInfoExtended[];
    sharing: ISharingModalState;
    isRestrictedOptionDisabled: boolean;
    isSharedOptionDisabled: boolean;
    isBannerShown: boolean;
    isSharingView?: boolean;
    onShare: (sharingState: ISharingModalState) => void;
    onChangeNotification: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    bannerComponent?: ReactNode;
    inviteUsersComponent?: ReactNode;
    footerComponent: ReactNode;
};

export const SharingModal: FC<ISharingModalProps> = ({
    modalProps,
    headerProps,
    text,
    users,
    sharing,
    isRestrictedOptionDisabled,
    isSharedOptionDisabled,
    isBannerShown,
    isSharingView = false,
    onShare,
    onChangeNotification,
    bannerComponent,
    inviteUsersComponent,
    footerComponent,
}): JSX.Element => (
    <ProModal {...modalProps}>
        <ContentContainer>
            <Header {...headerProps} />
            <SharingOptionsContainer
                text={text}
                users={users}
                sharing={sharing}
                onShare={onShare}
                isRestrictedOptionDisabled={isRestrictedOptionDisabled}
                isSharedOptionDisabled={isSharedOptionDisabled}
                isSharingView={isSharingView}
                onChangeNotification={onChangeNotification}
                inviteUsersComponent={inviteUsersComponent}
            />
            {isBannerShown ? bannerComponent : null}
            {footerComponent}
        </ContentContainer>
    </ProModal>
);
